module.exports = __webpack_public_path__ + "static/media/s.1104fa95.svg";